/* eslint-disable max-len */
export default {
    form: {
        title: 'Wypełnij formularz i pobierz ebooka',
        placeholder: {
            name: 'Imię',
            surname: 'Nazwisko',
            email: 'Twój email firmowy',
            company: 'Firma'
        },
        label: {
            checkbox: 'Dane administrowane są przez Sagiton Sp. z o.o., zostały przekazane dobrowolnie i będą przetwarzane przez administratora zgodnie z przepisami ustawy z dnia 29 sierpnia 1997r. o ochronie danych osobowych (Dz. U. z 2002r. nr 101, poz. 926 z późn. zm.) w celach marketingowych, sprzedaży produktów i usług Sagiton Sp.z o.o. Zostałem/am poinformowany/a o prawie dostępu do treści swoich danych, ich poprawiania oraz prawie wniesienia w każdym czasie sprzeciwu wobec ich przetwarzania.',
            checkbox2: 'Wyrażam zgodę na otrzymywanie od Sagiton Sp.z o.o. informacji handlowej za pomocą poczty elektronicznej.',
            button: 'Zapisz się!',
            refresh: 'Odśwież'
        }
    },
    footer: {
        title: 'Interesuje Cię kompleksowe rozwiązanie,<br/> związane z bezpieczeństwem gromadzonych przez Ciebie danych?',
        button: 'Sprawdź naszą ofertę'
    },
    subscribed: {
        text: 'Dziękujemy za rejestrację na webinar.<br/> Szczegóły zostaną przesłane na wskazany adres email. Prosimy o sprawdzenie skrzynki mailowej.'
    },
    list: [{
        slug: 'jak-zabezpieczyc-swoje-zasoby-cyfrowe-przed-cyberprzestepcami',
        header: {
            title: 'Zapisz się na darmowy webinar!',
            subtitle: 'Jak zabezpieczyć swoje zasoby cyfrowe przed cyberprzestępcami?',
            date: 'Data: 23 Kwietnia 12:00 CEST'
        },
        content: {
            title: 'W trakcie webinaru dowiesz się:',
            list: [
                'Jakie są zagrożenia i kto może stać się celem cyberprzestępców?',
                'Czym są luki zero-day i one-day?',
                'Jak zmniejszyć ryzyko infiltracji?',
                'Dlaczego dbanie o cyberbezpieczeństwo jest procesem ciągłym?'
            ],
            bottom_text: 'Webinar poprowadzi Bartłomiej Balcerek, ekspert <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'
        }
    }, {
        slug: 'jak-prowadzic-dzialania-marketingowe-zgodne-z-rodo',
        header: {
            title: 'Zapisz się na darmowy webinar!',
            subtitle: 'Jak prowadzić działania marketingowe zgodne z RODO?',
            date: 'Data: 12 Kwietnia 12:00 CEST'
        },
        content: {
            title: 'W trakcie webinaru dowiesz się:',
            list: [
                'Jak profilować użytkowników zgodnie z RODO?',
                'Jak powinny wyglądać zgody na przetwarzanie danych osobowych?',
                'Jak zarządzać uzyskanymi zgodami?',
                'Jak działy marketingu mogą zabezpieczać zbierane informacje?',
                'O 5 zasadach, które stoją za pomyślną współpracą miedzy działami marketingu a bezpieczeństwa.'
            ],
            bottom_text: 'Webinar poprowadzi Jarosław Greser i Marcin Michalski, eksperci <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'
        }
    }, {
        slug: 'zostalem-zhackowany-co-powinienem-zrobic',
        header: {
            title: 'Zapisz się na darmowy webinar!',
            subtitle: 'Zostałem zhackowany… Co powinienem zrobić?',
            date: 'Data: 24 Marca 12:00 CET'
        },
        content: {
            title: 'W trakcie webinaru dowiesz się:',
            list: [
                'Dlaczego większość firm, jeśli nawet zorientuje się, że została zaatakowana dowiaduje się o tym długo po dokonaniu ataku?',
                'Jakie procedury techniczne należy uruchomić w organizacji po doświadczeniu ataku?',
                'Jakie obowiązki prawne spoczywają na organizacjach, które zostały zaatakowane?',
                'Jakie są konsekwencje zaniedbania cyberbezpieczeństwa i aspektów ochrony danych?',
                'I najważniejsze, jak możesz się zabezpieczyć przed atakiem cyberprzestępców?'
            ],
            bottom_text: 'Webinar poprowadzi Bartłomiej Balecerk i Jarosław Greser, eksperci <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'
        }
    }, {
        slug: 'live-hacking-zobacz-jak-dzialaja-hakerzy-i-zwieksz-swoja-swiadomosc',
        header: {
            title: 'Zapisz się na darmowy webinar!',
            subtitle: 'Live Hacking - Zobacz jak działają hakerzy i zwiększ swoją świadomość.',
            date: 'Data: 14 Marca 12:00 CET'
        },
        content: {
            title: 'W trakcie webinaru dowiesz się:',
            list: [
                'Jakie są zagrożenia i kto może może stać się celem cyberprzestępców?',
                'Jak hakerzy mogą zaatakować Ciebie i Twoją organizację? - przykłady na żywo',
                'W jaki sposób Twoje zasoby cyfrowe mogą zostać wykorzystane do kradzieży pieniędzy, przejęcia kontroli nad komputerami użytkowników lub infiltracji kont administratora?',
                'I najważniejsze, jak możesz się zabezpieczyć przed atakiem cyberprzestępców?'
            ],
            bottom_text: 'Webinar poprowadzi Bartłomiej Balcerek, ekspert <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'
        }
    }, {
        slug: 'jak-przygotowac-aplikacje-zgodna-z-rodo',
        header: {
            title: 'Zapisz się na darmowy webinar!',
            subtitle: 'Jak przygotować aplikację zgodną z RODO?',
            date: 'Data: 31 Marca 12:00 CEST'
        },
        content: {
            title: 'W trakcie webinaru dowiesz się:',
            list: [
                'Czym jest RODO i jakie przepisy nakłada na organizację?',
                'Jakie aspekty związane z RODO są zwykle zaniedbywane lub pomijane przy tworzeniu aplikacji?',
                'Jak przygotować system i aplikację zgodną z RODO już na etapie projektowania?',
                'Jak dostosować gotowe już systemy i aplikacje do wymagań RODO?'
            ],
            bottom_text: 'Webinar poprowadzi Jarosław Greser i Grzegorz Mąkosa, eksperci <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'
        }
    }, {
        slug: 'jak-tworzyc-bezpieczne-systemy-i-aplikacje-it',
        header: {
            title: 'Zapisz się na darmowy webinar!',
            subtitle: 'Jak tworzyć bezpieczne systemy i aplikacje IT?',
            date: 'Data: 5 Kwietnia 12:00 CEST'
        },
        content: {
            title: 'W trakcie webinaru dowiesz się:',
            list: [
                'Jakie są zagrożenia i kto może stać się celem cyberprzestępców?',
                'Czym są koncepcje Security by Design i Security by Default oraz dlaczego należy o nich pamiętać przy tworzeniu aplikacji?',
                'Jak zwiększyć bezpieczeństwo aplikacji nie zmniejszając jej użyteczności?',
                'Jak sprawić, by dane użytkowników były nieużyteczne dla tych, którzy będą próbowali je wykraść?'
            ],
            bottom_text: 'Webinar poprowadzi Jarosław Greser i Grzegorz Mąkosa, eksperci <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'
        }
    }]
};



// WEBPACK FOOTER //
// ./src/i18n/pl/webinar.js